import { toast } from 'react-toastify'

export const useCopyToClipboard = () => {
  const copyToClipboard = async (
    text: string,
    successMessage = 'Скопировано!',
    errorMessage = 'Не удалось скопировать',
  ) => {
    if (!text) {
      toast.error('Нечего копировать')
      return
    }

    try {
      await navigator.clipboard.writeText(text)
      toast.success(successMessage, {
        autoClose: 1500,
        hideProgressBar: true,
      })
    } catch (err) {
      console.error('Ошибка копирования:', err)
      toast.error(errorMessage, {
        autoClose: 3000,
      })
    }
  }

  return { copyToClipboard }
}
